// Test IDs for the /advertise funnel (Hub + Agents / Sellers / Builders tracks).
// Only funnel-critical navigation/CTA elements are centralized here; individual
// form fields use inline kebab-case data-testid attributes following the same
// `<feature>-<element>` convention (see ./auth.js for the directive).

export const ADVERTISE_HUB = {
	agentsCta: 'advertise-hub-agents-cta',
	sellersCta: 'advertise-hub-sellers-cta',
	buildersCta: 'advertise-hub-builders-cta',
};

export const ADVERTISE_NAV = {
	back: 'advertise-back-button',
	next: 'advertise-next-button',
	stepper: 'advertise-stepper',
};

export const ADVERTISE_AGENTS = {
	landingCta: 'agents-landing-cta',
	planMembership: 'agents-plan-membership',
	planBoost: 'agents-plan-boost',
	planBoth: 'agents-plan-both',
	reviewSubmit: 'agents-review-submit',
	thankYouHeading: 'agents-thank-you-heading',
};

export const ADVERTISE_SELLERS = {
	landingCta: 'sellers-landing-cta',
	addressInput: 'sellers-address-street-input',
	verifyConfirm: 'sellers-verify-confirm',
	verifyNotMine: 'sellers-verify-not-mine',
	reviewSubmit: 'sellers-review-continue',
	checkoutSubmit: 'sellers-checkout-pay',
	thankYouHeading: 'sellers-thank-you-heading',
};

export const ADVERTISE_BUILDERS = {
	landingCta: 'builders-landing-cta',
	reviewSubmit: 'builders-review-submit',
	thankYouHeading: 'builders-thank-you-heading',
};
